import { InfoURLs } from '~/enums/URLs';
import { LinksTestIds } from '~/enums/TestIds';
import { LinkConfig } from './models';

// Keys must exactly match the link text segments in translation.json (welcome_view.legal_authorization).
// The LegalAuthorization component matches translation segments against these keys to render them as links.
export const LINK_MAP: Record<string, LinkConfig> = {
  'Privacy Policy': { type: 'info', url: InfoURLs.PrivacyPolicy, testId: LinksTestIds.PrivacyPolicy },
  'Arbitration Agreement': {
    type: 'info',
    url: InfoURLs.ArbitrationProvision,
    testId: LinksTestIds.ArbitrationProvision,
  },
  'Terms & Conditions': { type: 'info', url: InfoURLs.TermsAndConditions, testId: LinksTestIds.TermsAndConditions },
  'Terms of Use': { type: 'info', url: InfoURLs.TermsOfUse, testId: LinksTestIds.TermsOfUse },
  'records@sunbit.com': { type: 'email', href: 'mailto:records@sunbit.com' },
};

export const HEALTHCARE_COLLAPSED_KEYS = ['bullet_1'] as const;
export const HEALTHCARE_EXPANDED_KEYS = ['bullet_2', 'bullet_3', 'bullet_4'] as const;
